export default "__VITE_ASSET__BId2kf0x__"